/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "logo-square-4281fd23--sprite",
  "use": "logo-square-4281fd23--sprite-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 40 40\" id=\"logo-square-4281fd23--sprite\"><defs><linearGradient id=\"logo-square-4281fd23--sprite_a\" x1=\"0.125\" y1=\"-0.037\" x2=\"0.66\" y2=\"0.732\" gradientUnits=\"objectBoundingBox\"><stop offset=\"0\" stop-color=\"#f0f1c1\" /><stop offset=\"1\" stop-color=\"#26b0d5\" /></linearGradient></defs><rect width=\"40\" height=\"40\" fill=\"url(#logo-square-4281fd23--sprite_a)\" /><g transform=\"translate(4 12)\"><rect width=\"3.07\" height=\"20.49\" transform=\"translate(12.367 2.178) rotate(-45)\" fill=\"#fff\" /><rect width=\"20.49\" height=\"3.07\" transform=\"translate(0 14.489) rotate(-45)\" fill=\"#fff\" /><path d=\"M19.86,24v4.1H24V24Z\" transform=\"translate(-3.797 -11.436)\" fill=\"#fff\" /><path d=\"M12.68,24v4.1h4.1V24Z\" transform=\"translate(-3.797 -11.436)\" fill=\"#fff\" /><rect width=\"3.07\" height=\"12.56\" transform=\"translate(26.853 4.104)\" fill=\"#fff\" /><path d=\"M28.6,16.56l3.59-5.12,3.59,5.12Z\" transform=\"translate(-3.797 -11.436)\" fill=\"#fff\" /></g><g transform=\"translate(4 12)\"><rect width=\"3.07\" height=\"20.49\" transform=\"translate(12.367 2.178) rotate(-45)\" fill=\"#fff\" /><rect width=\"20.49\" height=\"3.07\" transform=\"translate(0 14.489) rotate(-45)\" fill=\"#fff\" /><path d=\"M19.86,24v4.1H24V24Z\" transform=\"translate(-3.797 -11.436)\" fill=\"#fff\" /><path d=\"M12.68,24v4.1h4.1V24Z\" transform=\"translate(-3.797 -11.436)\" fill=\"#fff\" /><rect width=\"3.07\" height=\"12.56\" transform=\"translate(26.853 4.104)\" fill=\"#fff\" /><path d=\"M28.6,16.56l3.59-5.12,3.59,5.12Z\" transform=\"translate(-3.797 -11.436)\" fill=\"#fff\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
